/* eslint-disable react-hooks/exhaustive-deps */
import DoctorList from "../../components/docotors-components/DoctorList";
import Hero from "../../components/hero/Hero";
import "./home.css";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDoctors } from "../../redux/apiCalls/doctorsApiCalls";

const Home = () => {
  const { doctors } = useSelector((state) => state.doctor);

  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchDoctors(1));
  }, []);

  return (
    <div className="home">
      <div>
        <Hero
          className="pt-5"
          pageTitle="اهلا بكم فى دليل اسيوط الطبى"
          pageDiscription="التطبيق تحت التجربة..."
        />
      </div>
      <div className="home-doctor-list-wrapper">
        <DoctorList doctors={doctors} />
        <Link className="link-page-btn" to="/doctors">
          <button className="home-page-btn">جميع الاطباء</button>
        </Link>
      </div>
    </div>
  );
};

export default Home;
